import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=8a403592&scoped=true&"
import script from "./EditTask.vue?vue&type=script&lang=js&"
export * from "./EditTask.vue?vue&type=script&lang=js&"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=8a403592&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a403592",
  null
  
)

export default component.exports